export const SELECT_MAP_LAYER = 'SELECT_MAP_LAYER';
export const DESELECT_MAP_LAYER = 'DESELECT_MAP_LAYER';
export const DESELECT_ALL_MAP_LAYERS = 'DESELECT_ALL_MAP_LAYERS';

export const ZOOM_TO_MAP_LAYER_EXTENT = 'ZOOM_TO_MAP_LAYER_EXTENT';
export const ZOOM_TO_MAP_HOME = 'ZOOM_TO_MAP_HOME';

export const TOGGLE_BASEMAP = 'TOGGLE_BASEMAP';

export const GEOJSON_LAYER_REQUEST = 'GEOJSON_LAYER_REQUEST';
export const GEOJSON_LAYER_SUCCESS = 'GEOJSON_LAYER_SUCCESS';
export const GEOJSON_LAYER_ERROR = 'GEOJSON_LAYER_ERROR';

export const SELECT_LAYERS_TAB = 'SELECT_LAYERS_TAB';
export const SIDEBAR_EXPAND = 'SIDEBAR_EXPAND';
export const SIDEBAR_COLLAPSE = 'SIDEBAR_COLLAPSE';

export const LIGHTBOX_OPEN = 'LIGHTBOX_OPEN';
export const LIGHTBOX_CLOSE = 'LIGHTBOX_CLOSE';



// WEBPACK FOOTER //
// ./src/common/actionTypes.js